<div id="ranking-filial" style="padding-left: 8px; padding-right: 8px;">
  <div class="p-row">
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mt-2">
      <po-widget>
        <div class="po-pl-0">
          <span class="po-font-text-bold">Ranking loja</span>
          <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" [p-tooltip]="topTooltipExcel" (click)="downloadExcel()"></span>
        </div>
        <div id="total" class="po-mb-2 po-mt-1" *ngIf="!errorApi">
          <po-table [p-items]="tableRankingTotal" [p-sort]="false" [p-loading]="loading" [p-striped]="true"></po-table>
        </div>
        <div *ngIf="!errorApi" id="table-geral">
          <po-table [p-items]="tableRanking" [p-sort]="true" [p-loading]="loading" [p-striped]="true"></po-table>
        </div>
        <div class="po-text-center po-pt-5" *ngIf="errorApi">
          <app-error [message]="message"></app-error>
        </div>
      </po-widget>
    </div>
  </div>
</div>